import { useEffect,useState } from "react";
import ReactSelect from '@src/common/ReactSelect';

const RejectReasonPopup = (props: any) => {
    let {show,reason,confirmYes} = props;
    const [selectedReason, setSelectedReason] = useState<string | null>(null);
    const [remarks, setRemarks] = useState<string>("");
    let [errors, setErrors] = useState<any>({})
    useEffect(()=>{
        if(show) document.body.classList.add("overflow-hidden");
        return ()=>{
            document.body.classList.remove("overflow-hidden");
        }
    }, [show])

    const validateForm = (): boolean => {
        const newErrors: Record<string, string> = {};
        let isValid = true;

        if (!selectedReason) {
            newErrors['reject_reason'] = 'Rejection reason is required.';
            isValid = false;
        }

        if (!remarks.trim()) {
            newErrors['remarks'] = 'Remarks are required.';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSave = () => {
        if (validateForm()) {
            confirmYes({
                reject_reason: selectedReason,
                reject_remark: remarks.trim(),
            });
        }
    };

    return (
        <div className="mark-lost-popup">
            <div className="modal display-block" role="dialog">
                <section className="modal-main" role="document">
                    <div className="modal-header">
                        <h2 className="modal-title">{props.title || 'Rejection Reason'}</h2>
                        <button type="button" className="close_icn" data-dismiss="modal" aria-label="Close" onClick={() => {
                            props.confirmNo();
                        }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <ReactSelect
                                options={reason ?? []}
                                value={reason?.find((r: any) => r.value === selectedReason) || null}
                                handleChange={(selected: any) => setSelectedReason(selected?.value || null)}
                                placeholder={"Select Rejection Reason *"}
                                fieldSetClassName="col-md-12"
                                errorField={errors.reject_reason}
                            />
                            <div className="col-md-12">   
                                <fieldset className="form-filed add-remarks-filed">
                                    <div className="material">
                                        <textarea placeholder=" " className="form-input" rows={3} onChange={(e) => setRemarks(e.target.value)}></textarea>
                                        <label data-label="Add Remarks *" className="form-label"></label>
                                        {
                                            errors && errors.remarks
                                                ?
                                                <span className="error-txt">{errors.remarks}</span>
                                                :
                                                ''
                                        }
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary btn-lg m-sm-r rejection-reason" onClick={handleSave}>Save</button>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default RejectReasonPopup;